(function(){
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  qsa('[data-tg-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var el=document.getElementById(btn.getAttribute('data-tg-toggle'));
      if(!el)return;
      var open=el.hasAttribute('hidden');
      if(open){el.removeAttribute('hidden');}else{el.setAttribute('hidden','');}
      btn.setAttribute('aria-expanded',open?'true':'false');
      if(open){var i=el.querySelector('input');if(i)i.focus();}
    });
  });
  qsa('[data-tg-qty]').forEach(function(w){
    var input=w.querySelector('input');
    var min=parseInt(input.getAttribute('min')||'1',10);
    function set(v){input.value=Math.max(min,v);input.dispatchEvent(new Event('change',{bubbles:true}));}
    var dn=w.querySelector('[data-tg-minus]'),up=w.querySelector('[data-tg-plus]');
    if(dn)dn.addEventListener('click',function(){set((parseInt(input.value,10)||min)-1);});
    if(up)up.addEventListener('click',function(){set((parseInt(input.value,10)||0)+1);});
  });
  qsa('[data-tg-autosubmit]').forEach(function(f){
    var t;f.addEventListener('change',function(){clearTimeout(t);t=setTimeout(function(){f.submit();},600);});
  });
  qsa('[data-tg-gallery]').forEach(function(g){
    var main=g.querySelector('[data-tg-main]');
    qsa('[data-tg-thumb]',g).forEach(function(t){
      t.addEventListener('click',function(){
        main.src=t.getAttribute('data-src');main.removeAttribute('srcset');main.alt=t.getAttribute('data-alt')||'';
        qsa('[data-tg-thumb]',g).forEach(function(x){x.setAttribute('aria-current','false');});
        t.setAttribute('aria-current','true');
      });
    });
  });
  qsa('[data-tg-product]').forEach(function(root){
    var json=root.querySelector('[data-tg-variants]');if(!json)return;
    var variants=JSON.parse(json.textContent);
    var sel=root.querySelector('[data-tg-variant-select]');if(!sel)return;
    sel.addEventListener('change',function(){
      var v=variants.filter(function(x){return String(x.id)===sel.value;})[0];if(!v)return;
      var p=root.querySelector('[data-tg-price]');if(p&&v.price)p.textContent=v.price;
      var s=root.querySelector('[data-tg-sku]');if(s)s.textContent=v.sku||'';
      var b=root.querySelector('[data-tg-add]');
      if(b){b.disabled=!v.available;b.textContent=v.available?b.getAttribute('data-label'):b.getAttribute('data-soldout');}
      var img=document.querySelector('[data-tg-main]');if(img&&v.image){img.src=v.image;img.removeAttribute('srcset');}
      if(window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
    });
  });
  qsa('[data-tg-sort]').forEach(function(s){
    s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString();});
  });
})();